var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8471 11.1765C31.0706 10.5059 31.2941 9.83529 31.2941 8.94118C31.2941 4.02353 27.2706 0 22.3529 0C19 0 15.8706 2.01176 14.5294 4.91765C13.8588 4.69412 12.9647 4.47059 12.2941 4.47059C9.16471 4.47059 6.70588 6.92941 6.70588 10.0588C6.70588 10.5059 6.70588 10.9529 6.92941 11.1765C2.90588 11.8471 0 14.9765 0 19C0 23.2471 3.57647 26.8235 7.82353 26.8235H30.1765C34.4235 26.8235 38 23.2471 38 19C38 14.9765 34.8706 11.6235 30.8471 11.1765ZM16.7647 24.3647L9.61176 17.2118L12.7412 14.0824L16.7647 18.1059L25.2588 9.61176L28.3882 12.7412L16.7647 24.3647Z",
    fill: "#06513D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.91ee5ff36e8de296a622b429ee1045eb.svg";
export { ForwardRef as ReactComponent };